import { BoardScene } from "./BoardScene";
import { GameConstants } from "../../GameConstants";
import { Button } from "../../utils/Utils";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";

export class GiveUpLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.visible = false;

        let bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0x000000, .75);
        bck.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        bck.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        bck.on("pointerdown", () => { 
            //
        });
        this.add(bck);

        let pauseText = new Phaser.GameObjects.Text(this.scene, 30, 10, GameVars.gameText.GAME[3], {fontFamily: "HelveticaNeue", fontSize: "60px", color: "#FFFFFF"});
        this.add(pauseText);

        let bck2 = new Phaser.GameObjects.Graphics(this.scene);
        bck2.fillStyle(0x000000, .75);
        bck2.fillRoundedRect(GameConstants.GAME_WIDTH / 2 - 300, GameConstants.GAME_HEIGHT / 2 - 200, 600, 300, 40);
        this.add(bck2);

        let giveUpText = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, 300, GameVars.gameText.GAME[5], {fontFamily: "HelveticaNeue", fontSize: "40px", color: "#fecf27"});
        giveUpText.setOrigin(.5);
        this.add(giveUpText);

        let giveUp2Text = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, 360, GameVars.gameText.GAME[6], {fontFamily: "HelveticaNeue", fontSize: "35px", color: "#ffffff"});
        giveUp2Text.setOrigin(.5);
        this.add(giveUp2Text);

        let btnOk = new Button(this.scene, GameConstants.GAME_WIDTH / 2 - 95, 490, "texture_atlas_language", "btn_accept", "btn_accept_hover");
        btnOk.onDown(this.onOkDown, this);
        this.add(btnOk);

        let btnCancel = new Button(this.scene, GameConstants.GAME_WIDTH / 2 + 95, 490, "texture_atlas_language", "btn_cancel", "btn_cancel_hover");
        btnCancel.onDown(this.onCancelDown, this);
        btnCancel.setScale(.55);
        this.add(btnCancel);
    }

    private onOkDown(): void {

        AudioManager.playSound("click");

        BoardScene.currentInstance.endGame(GameConstants.END_LOSE);
        BoardScene.currentInstance.hideGiveUpLayer(); 
    }

    private onCancelDown(): void {

        AudioManager.playSound("click");

        BoardScene.currentInstance.hideGiveUpLayer(); 
    }
}
